import { render, staticRenderFns } from "./logosSVG.vue?vue&type=template&id=00ab186b"
import script from "./logosSVG.vue?vue&type=script&lang=js"
export * from "./logosSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports